<template>
    <fees-find
        :params="{ fee: $route.params.fee }"
        :include="['tenancy']"
    >
        <div
            slot-scope="{
                data: fee,
                error,
                has_loaded,
                find
            }"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <pay-tenancy
                    :initial-amount="fee.payable"
                    :rents="[fee]"
                    @success="onSuccess"
                    @error="onError"
                />

                <modal-success :is-open="show_succeeded_modal">
                    <template slot="heading">Payment Successful!</template>

                    <p>
                        Thanks for your payment! We'll send you a confirmation email.
                    </p>

                    <p class="mt-3 text-sm">
                        p.s. It may take a moment for this payment appear on your dashboard and be reflected on the fee's balance.
                    </p>

                    <div
                        slot="footer"
                        class="flex flex-col md:flex-row-reverse"
                    >
                        <router-link
                            :to="{
                                name: $router.fix('dashboard.*.fees.show'),
                                params: {
                                    fee: fee.uuid
                                }
                            }"
                            class="text-center btn btn-green"
                        >
                            Go to Fee
                        </router-link>
                    </div>
                </modal-success>

                <modal-error
                    :is-open="show_failed_modal"
                    @close="show_failed_modal = false"
                >
                    <template slot="heading">Payment Failed</template>

                    <p>
                        We were unable to process your payment. We've sent you
                        an email confirming this.
                    </p>

                    <div
                        slot="footer"
                        slot-scope="{ close }"
                        class="flex flex-col md:flex-row-reverse"
                    >
                        <button
                            type="button"
                            class="text-center btn btn-red"
                            @click.prevent="close"
                        >
                            Try Again
                        </button>
                    </div>
                </modal-error>
            </template>
        </div>
    </fees-find>
</template>

<script>
    import scroll from '../../../../../support/scroll'
    import FeesFind from '../../../../../components/fees-find'
    import PayTenancy from '../../../../../components/pay-tenancy'

    export default {
        components: {
            FeesFind,
            PayTenancy
        },
        data () {
            return {
                show_succeeded_modal: false,
                show_failed_modal: false
            }
        },
        methods: {
            onSuccess () {
                this.$track(
                    'dashboard._.fees.charges.create',
                    'form-submission',
                    'A user has made a payment.'
                )

                setTimeout(() => {
                    this.show_succeeded_modal = true
                }, 0)
            },
            onError () {
                scroll.toTop()

                /*
                if (this.$error.is(error, { exclude: [422, 500] })) {
                    setTimeout(() => {
                        this.show_failed_modal = true
                    }, 0)
                }
                */
            }
        }
    }
</script>
